var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C18.6274 20 24 14 24 12C24 10 18.6274 4 12 4C5.37258 4 0 10 0 12C0 14 5.37258 20 12 20ZM12 16.6C14.5405 16.6 16.6 14.5405 16.6 12C16.6 9.45949 14.5405 7.4 12 7.4C9.45948 7.4 7.39999 9.45949 7.39999 12C7.39999 14.5405 9.45948 16.6 12 16.6ZM15 12C15 13.6569 13.6568 15 12 15C10.3431 15 8.99999 13.6569 8.99999 12C8.99999 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z",
    fill: "#18213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.7fb557ae7e4c4fc230771b62e79b3d3c.svg";
export { ForwardRef as ReactComponent };